module.exports = __webpack_public_path__ + "07f3e478f991a998a7e9ab7e4ed716e0.png";


//////////////////
// WEBPACK FOOTER
// ./apps/www.relic.com/src/img/styles/medium/public/games/coh_image_2.png
// module id = 496
// module chunks = 0